import * as types from './mutation-types';
import * as actions from './actions';

const state = {
    exceptionTypes: [],
    exceptionTypesLoading: false,
    exceptionTypesError: {},
    exceptionList: [],
    exceptionListLoading: false,
    exceptionListError: {},
    exceptionStatuses: [],
    getExceptionStatusesLoading: false,
    getExceptionStatusesError: {},
    ExceptionRemediationResult: {},
    setExceptionRemediationLoading: false,
    setExceptionRemediationError: {},
    exceptionRemediations: [],
    getExceptionRemediationsLoading: false,
    getExceptionRemediationsError: {},
    updatedExceptionRemediation: {},
    updateExceptionRemediationsLoading: false,
    updateExceptionRemediationsError: {}
}
const getters = {
    exceptionTypes: (state) => state.exceptionTypes,
    exceptionTypesLoading: (state) => state.exceptionTypesLoading,
    exceptionTypesError: (state) => state.exceptionTypesError,
    exceptionList: (state) => state.exceptionList,
    exceptionListLoading: (state) => state.exceptionListLoading,
    exceptionListError: (state) => state.exceptionListError,
    exceptionStatuses: (state) => state.exceptionStatuses,
    getExceptionStatusesLoading: (state) => state.getExceptionStatusesLoading,
    getExceptionStatusesError: (state) => state.getExceptionStatusesError,
    ExceptionRemediationResult: (state) => state.ExceptionRemediationResult,
    setExceptionRemediationLoading: (state) => state.setExceptionRemediationLoading,
    setExceptionRemediationError: (state) => state.setExceptionRemediationError,
    exceptionRemediations: (state) => state.exceptionRemediations,
    getExceptionRemediationsLoading: (state) => state.getExceptionRemediationsLoading,
    getExceptionRemediationsError: (state) => state.getExceptionRemediationsError,
    updatedExceptionRemediation: (state) => state.updatedExceptionRemediation,
    updateExceptionRemediationsLoading: (state) => state.updateExceptionRemediationsLoading,
    updateExceptionRemediationsError: (state) => state.updateExceptionRemediationsError,
}

const mutations = {
    [types.GET_EXCEPTION_TYPES_REQUEST] (state) {
        state.exceptionTypesLoading = true;
        state.exceptionTypesError = '';
        state.exceptionTypes = [];
    },
    [types.GET_EXCEPTION_TYPES_SUCCESS] (state, exceptionTypes) {
        state.exceptionTypesLoading = false;
        state.exceptionTypesError = '';
        state.exceptionTypes = exceptionTypes;
    },
    [types.GET_EXCEPTION_TYPES_FAILURE] (state, error) {
        state.exceptionTypesLoading = false;
        state.exceptionTypesError = error;
        state.exceptionTypes = [];
    },
    [types.GET_EXCEPTION_LIST_REQUEST] (state) {
        state.exceptionListLoading = true;
        state.exceptionListError = '';
        state.exceptionList = [];
    },
    [types.GET_EXCEPTION_LIST_SUCCESS] (state, exceptionList) {
        state.exceptionListLoading = false;
        state.exceptionListError = '';
        state.exceptionList = exceptionList;
    },
    [types.GET_EXCEPTION_LIST_FAILURE] (state, error) {
        state.exceptionListLoading = false;
        state.exceptionListError = error;
        state.exceptionList = [];
    },
    [types.GET_EXCEPTION_STATUSES_REQUEST] (state) {
        state.getExceptionStatusesLoading = true;
        state.getExceptionStatusesError = {};
        state.exceptionStatuses = [];
    },
    [types.GET_EXCEPTION_STATUSES_SUCCESS] (state, exceptionStatuses) {
        state.getExceptionStatusesLoading = false;
        state.getExceptionStatusesError = {};
        state.exceptionStatuses = exceptionStatuses;
    },
    [types.GET_EXCEPTION_STATUSES_FAILURE] (state, error) {
        state.getExceptionStatusesLoading = false;
        state.getExceptionStatusesError = error;
        state.exceptionStatuses = [];
    },
    [types.SET_EXCEPTION_REMEDIATION_REQUEST] (state) {
        state.setExceptionRemediationLoading = true;
        state.setExceptionRemediationError = {};
        state.ExceptionRemediationResult = {};
    },
    [types.SET_EXCEPTION_REMEDIATION_SUCCESS] (state, ExceptionRemediationResult) {
        state.setExceptionRemediationLoading = false;
        state.setExceptionRemediationError = {};
        state.ExceptionRemediationResult = ExceptionRemediationResult;
    },
    [types.SET_EXCEPTION_REMEDIATION_FAILURE] (state, error) {
        state.setExceptionRemediationLoading = false;
        state.setExceptionRemediationError = error;
        state.ExceptionRemediationResult = {};
    },
    [types.GET_EXCEPTION_REMEDIATIONS_REQUEST] (state) {
        state.getExceptionRemediationsLoading = true;
        state.getExceptionRemediationsError = {};
        state.exceptionRemediations = [];
    },
    [types.GET_EXCEPTION_REMEDIATIONS_SUCCESS] (state, exceptionRemediations) {
        state.getExceptionRemediationsLoading = false;
        state.getExceptionRemediationsError = {};
        state.exceptionRemediations = exceptionRemediations;
    },
    [types.GET_EXCEPTION_REMEDIATIONS_FAILURE] (state, error) {
        state.getExceptionRemediationsLoading = false;
        state.getExceptionRemediationsError = error;
        state.exceptionRemediations = [];
    },
    [types.UPDATE_EXCEPTION_REMEDIATIONS_REQUEST] (state) {
        state.updateExceptionRemediationsLoading = true;
        state.updateExceptionRemediationsError = {};
        state.updatedExceptionRemediation = {};
    },
    [types.UPDATE_EXCEPTION_REMEDIATIONS_SUCCESS] (state, updatedExceptionRemediation) {
        state.updateExceptionRemediationsLoading = false;
        state.updateExceptionRemediationsError = {};
        state.updatedExceptionRemediation = updatedExceptionRemediation;
    },
    [types.UPDATE_EXCEPTION_REMEDIATIONS_FAILURE] (state, error) {
        state.updateExceptionRemediationsLoading = false;
        state.updateExceptionRemediationsError = error;
        state.updatedExceptionRemediation = {};
    }
}

export default{
    state,
    actions,
    getters,
    mutations
}
